import { useEffect, useState } from "react";

export enum OS {
  Windows = "Windows",
  Linux = "Linux",
  MacOS = "MacOS",
  iOS = "iOS",
  Android = "Android",
  Unknown = "Unknown",
}

export const useOS = () => {
  const [os, setOS] = useState<OS>(OS.Unknown);
  const isAppleOS = () => [OS.MacOS, OS.iOS].includes(os);
  const isMobileOS = () => [OS.iOS, OS.Android].includes(os);

  useEffect(() => {
    if (/windows/i.test(navigator.userAgent)) {
      setOS(OS.Windows);
    } else if (/iphone/i.test(navigator.userAgent)) {
      setOS(OS.iOS);
    } else if (/ipad/i.test(navigator.userAgent)) {
      setOS(OS.iOS);
    } else if (/macintosh/i.test(navigator.userAgent)) {
      setOS(OS.MacOS);
    } else if (/android/i.test(navigator.userAgent)) {
      setOS(OS.Android);
    } else if (/linux/i.test(navigator.userAgent)) {
      setOS(OS.Linux);
    }
  }, [navigator.userAgent]);

  return { os, isAppleOS, isMobileOS };
};
